import Product1 from '@neo.tax/shared/assets/images/product-screenshots/product_1.png';
import Product2 from '@neo.tax/shared/assets/images/product-screenshots/product_2.png';
import Product3 from '@neo.tax/shared/assets/images/product-screenshots/product_3.png';
import Product4 from '@neo.tax/shared/assets/images/product-screenshots/product_4.png';

export const screenshots = [Product1, Product2, Product3, Product4];
